<template>
  <div class="book-grid">
    <slot name="empty"></slot>
    <div v-if="books.length > 0" class="book-list-content">
      <div class="book-box" v-for="book in books" :key="book.id">
        <van-checkbox
          v-if="selectable"
          :class="['check-box', book.selected ? 'check-box-checked' : 'check-box-unchecked']"
          checked-color="#996EFF"
          v-model="book.selected"
        ></van-checkbox>
        <NvBookCover :showProgress="true" @click="handleClick(book)" :book="book" :selectable="selectable" />
      </div>
      <div v-if="$slots.append" class="book-box flex-center book-add-box shadow-box">
        <slot name="append"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import NvBookCover from "@/components/widget/book/NvBookCover";

export default {
  name: "NvBookGrid",
  components: {
    NvBookCover
  },
  props: {
    books: Array,
    selectable: Boolean
  },
  data() {
    return {};
  },
  methods: {
    handleClick(book) {
      this.$set(book, "selected", !book.selected);
    }
  }
};
</script>

<style lang="scss" scoped>
.book-grid {
  margin-top: 45px;
  display: flex;
  justify-content: center;
  .book-list-content {
    margin: 32px 16px;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    .book-box {
      margin: 0 5px;
      position: relative;
      margin-bottom: 16px;
      .check-box {
        position: absolute;
        border-radius: 50%;
        background: #000000;
        top: 4px; // match with left label
        right: 10px;
        z-index: 9;
        &.check-box-checked {
          opacity: 1;
          background: transparent;
        }
        &.check-box-unchecked {
          opacity: 0.4;
          border: none;
        }
      }
      &.book-add-box {
        background: $bg-main;
        border-radius: 6px;
        // margin: 0 5px;
        height: 9rem;
        .icon-big {
          font-size: 50px;
          color: $fc-grey;
        }
      }
    }
  }
}
</style>
